import {GeoPoint} from "../types/api/GeoPoint";

export function mapCoordinatesToGeoPoints(coordinates: Array<[number, number]>) {
    const geoPoints: GeoPoint[] = coordinates.map(([latitude, longitude, ]): GeoPoint => ({
        longitude: longitude,
        latitude: latitude
    }));
    return geoPoints;
}

export function mapCoordinateToGeoPoint(coordinates: [number, number]) {
    if (!coordinates) return;
    const geoPoint: GeoPoint = {
        latitude: coordinates[0],
        longitude: coordinates[1]
    }
    return geoPoint;
}


export function mapStringToCoordinate(coordinate: string) {
    if (!coordinate) return;
    const item = coordinate.trim().split(',')
    const lat = parseFloat(`${item[0]}.${item[1]}`);
    const lon = parseFloat(`${item[2]}.${item[3]}`);
    return [lat, lon];
}